import { useHistory } from 'react-router'
import React, { useCallback } from 'react'
import styled from 'styled-components'

import Success from 'components/EditPost/Success'
import { JobDeleteConfirm } from 'utils/text'

const PageWrapper = styled.div`
	width: 100%;
	max-width: 100%;
	background-color: #fff;
	overflow: auto;
	position: relative;
	min-height: 100vh;
`;

export default function EditJobPostSuccessPage() {
	const history = useHistory()
	return (
		<PageWrapper>
			<Success
				header={JobDeleteConfirm.JobDeleteHeader}
				text={JobDeleteConfirm.JobDeleteText}
				buttonText={JobDeleteConfirm.JobDeleteButton}

				onClose={useCallback(() => {
					history.replace('jobBoard')
				}, [history])}
				onBackToJobPostings={useCallback(() => {
					history.replace('jobBoard')
				}, [history])}
			/>
		</PageWrapper>
	)
}
